import React from "react";
import UpdateAddress from "../components/Profile/UpdateAddress";

const UpdateAddressPage = () => {
  return <UpdateAddress />;
};

export default UpdateAddressPage;
